import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AdminToggle = () => {
  const { pathname } = useLocation();

  // Only show on store routes, not on admin routes
  if (pathname.startsWith('/admin')) return null;

  return (
    <Link
      to="/admin"
      className="fixed bottom-4 right-4 z-50 px-3 py-1 rounded-full text-xs bg-white border border-brand-main text-brand-dark shadow-sm hover:bg-brand-main transition-colors font-medium"
    >
      Admin
    </Link>
  );
};

export default AdminToggle;
